export default __webpack_public_path__ + "static/media/banner-img.b6f91a33.svg";